<template>
    <div class="container">
        <div id="authcontainer"></div>
    </div>
</template>

<script>
    export default {
        name: 'login',
        mounted() {
            if (!this.$Firebase.auth().currentUser) {
                this.$AuthUI.start('#authcontainer', {
                    signInSuccessUrl: "/sets",
                    callbacks: {
                        signInSuccess: (authResult, redirectUrl) => {
                            console.log(redirectUrl)
                            return !this.$router.push('/sets');
                        }
                    },
                    credentialHelper: firebaseui.auth.CredentialHelper.ACCOUNT_CHOOSER_COM,
                    signInOptions: [
                        // Leave the lines as is for the providers you want to offer your users.
                        this.$Firebase.auth.GoogleAuthProvider.PROVIDER_ID,
                        this.$Firebase.auth.FacebookAuthProvider.PROVIDER_ID,
                        this.$Firebase.auth.TwitterAuthProvider.PROVIDER_ID,
                        this.$Firebase.auth.EmailAuthProvider.PROVIDER_ID,
                        firebaseui.auth.AnonymousAuthProvider.PROVIDER_ID
                    ]
                });
            } else {
                this.$router.push({
                    name: 'Sets',
                });
            }
        },
        data() {
            return {}
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/login.vue